import styled from 'styled-components';
import { AgreementTitle, Statement } from 'app/Pages/Quote/Profile/body/Issuing/components/AgreementsCommon/styles';

export { AgreementTitle, Statement };

export const FormWrapper = styled.div`
  padding-top: 24px;
`;

export const StatementDot = styled.div`
  background-color: ${({ theme }) => theme.colors.textSecondary};
  border: 1px solid transparent;
  border-radius: 50%;
  width: 6px;
  height: 6px;
  flex-shrink: 0;
  margin-top: 6px;
`;

export const SecondaryAgreementsWrapper = styled.div<{ expanded: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: ${({ expanded }) => expanded ? null: 0};
  overflow: hidden;
  padding: ${({ expanded }) => expanded ? '20px 0 10px 0' : '0 0 0 20px'};
`;

export const AgreementItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${AgreementTitle} {
    align-self: flex-start;
  }
`;

export const AgreementWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

export const InspectionWrapper = styled.div`
  line-height: normal;
  font-family: ${({ theme }) => theme.font.light};
  display: grid;
  gap: 10px;
`;

export const InspectionText = styled.p`
  font-size: 14px;
  a {
    color: ${({ theme }) => theme.colors.primary };
  }
`;

export const InspectionSubTitle = styled.h4`
`;
